<template>
  <div>
    <acheader></acheader>
    <div class="row mainbody">
      <div class="col-lg-2 col-md-4 col-sm-12">
        <clientsidebar></clientsidebar>
      </div>
      <div class="col-lg-10 col-md-8 col-sm-12">
        <div class="moduleWrapper">
          <div class="moduleCard">
          <div v-if="mode==='1'">
            <h2>Add Certificate</h2>
            <p><label class="text-dark">Certificate Name:</label><br /><input type='text' v-model='CertificateName' class="w50" /></p>
            <p>Choose an image file for the certificate. The image must be 1017 pixels wide by 777 pixels tall and have dedicated space for the student's name and date of completion.</p>
            <p><input type='file' id='fileinput' ref="tfiles" class='w50 ib mb-0' @change="getFile" /></p>
            <p><button class="btn btn-primary btn-short" @click="doStepOne">Upload</button></p>
          </div>
          <div v-if="mode==='2'">
            <div class="row">
            <div class="col-9 certblock">
              <img v-bind:src="CertStyle" width="1017" height="777" alt="Certificate" @click="captureImage" />

              <canvas id="nameCanvas" class="icanvas" width='1017' height='777' v-show="tcanvas==='name'&&capturing===false" />
              <canvas id="docCanvas" class="icanvas" width='1017' height='777' v-show="tcanvas==='completion'&&capturing===false" />
                       
            </div>
            <div class="col-3">
               
              <p>To add a name and completion date to your certificate click on each attribute below and then on Capture. Then click on the image where you want the upper-leftmost corner of the text field to begin. After this, click on the image where you want the lower-rightmost corner of the text field to be.</p> 
              <p>
                  <input type='checkbox' v-model='useWhiteFont'> Use White Font For Dark Backgrounds
              </p>
              <hr />
              <p>
                <a href='javascript:void(0)' @click="doNameCanvas">Name</a> | <a href='javascript:void(0)' @click="doCompletionCanvas">Date of Completion</a>
              </p> 
              <hr />
              <div id='namePanel' v-show="tcanvas==='name'">

                <p><b>Name</b></p>
                <p><a href='javascript:void(0)' @click="captureDraw" id='nameCapture'>Capture (<span v-show="capturing===false">Not</span> <span v-show="capturephase<2">Capturing</span><span v-show="capturephase===2">Capture Finished - Click to Recapture</span>)</a></p>
                <div class="row">

                  <div class="col-6">Text Alignment: </div><div class="col-6"><select v-model='NameAlign' style='margin-bottom:1vh;'><option value='Left'>Left</option><option value='Center'>Center</option><option value='Right'>Right</option></select></div>
                </div>
                <div class="row mt-2">

                  <div class="col-6">
                    Name X:</div><div class="col-6"><input type='text' class="fullWidth" v-model='NameX' disabled='disabled' /></div>
                  </div>
                <div class="row mt-2">
                  <div class="col-6">
                    Name Y:</div><div class="col-6"><input type='text' class="fullWidth" v-model='NameY' disabled='disabled' /></div>
                  </div>
                <div class="row mt-2">
                  <div class="col-6">
                    Name Width:</div><div class="col-6"><input type='text' class="fullWidth" v-model='NameWidth' disabled='disabled' /></div>
                  </div>
                  <div class="row mt-2">
                    <div class="col-6">
                      Name Height:
                    </div>
                    <div class="col-6">
                      <input type='text'  v-model='NameHeight' class="fullWidth" disabled='disabled' />
                    </div>

                    </div>

                  </div> 
              <div id='docPanel' v-show="tcanvas==='completion'">

                <p><b>Date of Completion</b></p>
                <p><a href='javascript:void(0)' @click="captureDraw" id='docCapture'>Capture (<span v-show="capturing===false&&capturephase!==2">Not</span> <span v-show="capturephase<2">Capturing</span><span v-show="capturephase===2">Capture Finished - Click to Recapture</span>)</a></p>
                <div class="row">

                  <div class="col-6">
                    Text Alignment: </div><div class="col-6"><select v-model='DateAlign' style='margin-bottom:1vh;'><option value='Left'>Left</option><option value='Center'>Center</option><option value='Right'>Right</option></select></div>
                  </div>
                <div class="row mt-2">
                  <div class="col-6">
                    Date X:</div><div class="col-6"><input type='text' class="fullWidth" v-model='DateX' disabled='disabled' /></div>
                  </div>
                <div class="row mt-2">
                  <div class="col-6">
                    Date Y:</div><div class="col-6"><input type='text' class="fullWidth" v-model='DateY' disabled='disabled' /></div>
                  </div>
                <div class="row mt-2">
                  <div class="col-6">
                    Date Width:</div><div class="col-6"><input type='text' class="fullWidth" v-model='DateWidth' disabled='disabled' /></div>
                  </div>
                <div class="row mt-2">
                  <div class="col-6">
                    Date Height:</div><div class="col-6"><input type='text' class="fullWidth" v-model='DateHeight' disabled='disabled' /></div>
                  </div>

              </div> 

              <hr />
              <div class="row mt-2">
                 <div class="col-12 text-right">
                    <button class="btn btn-primary" @click="doSave">Save</button>
                 </div>
              </div>
            </div> 
            </div>
          </div>
          </div>
        </div>       
      </div>
    <div class="clearfix"></div></div><acfooter></acfooter>

  </div>
</template>

<style scoped>
  .certblock {
    overflow: auto;
    position:relative;
  }
  .icanvas {
    position:absolute;
    top:0;
    left:0;
  }
</style>

<script>
  import "core-js/stable";
  import "regenerator-runtime/runtime";
  import acheader from "../../layout/Header.vue"
  import acfooter from "../../layout/Footer.vue"
  import clientsidebar from "../../layout/Client/Sidebar.vue"

  export default {
    name: 'AddCertificate',
    components:{acheader,acfooter,clientsidebar},
    data() {
      return {
        tcanvas:null,
        capturephase:0,
        capturing:false,
        CertificateID:null,
        CertificateName:'',
        CertStyle:null,
        DateAlign:'Left',
        DateX:null,
        DateY:null,
        DateWidth:null,
        DateHeight:null,
        NameAlign:'Left',
        NameX:null,
        NameY:null,
        NameWidth:null,
        NameHeight:null,
        fdata:null,
        mode:'0',
        startX:null,
        startY:null,
        useWhiteFont:false
      }
    },
    methods: {
      captureDraw() {
        var canvas=null;

        if (this.capturephase === 2) {
         
          if (this.tcanvas=== "name") {
            canvas = document.getElementById("nameCanvas");
          }
          else {
            canvas = document.getElementById("docCanvas");
          }

          if (canvas !== null) {
            var  context = canvas.getContext('2d');
            context.clearRect(0, 0, canvas.width, canvas.height);
          }

          this.capturephase = 0;
        }

        this.capturing=true;
      },
      captureImage(e) {

        if (!this.capturing) {
          return;
        }

        if (this.capturephase === 0) {
 
          this.startX = e.offsetX;
          this.startY = e.offsetY;

          if (this.tcanvas === "name") {
            this.NameX=Math.round(this.startX);
            this.NameY=Math.round(this.startY);
          }
          else {
            this.DateX=Math.round(this.startX);
            this.DateY=Math.round(this.startY);
          }

          this.capturephase++;
        }
        else if (this.capturephase === 1) {

          var width = e.offsetX - this.startX;
          var height = e.offsetY - this.startY;
          if (width < 10 || height < 10) {
            return;
          }

          this.capturing=false;
          var canvas=null;

          if (this.tcanvas === "name") {
            this.NameWidth=Math.round(width);
            this.NameHeight=Math.round(height);
            canvas = document.getElementById("nameCanvas");
          }
          else {
            this.DateWidth=Math.round(width);
            this.DateHeight=Math.round(height);
            canvas = document.getElementById("docCanvas");
          }

          var context = canvas.getContext('2d');

          context.beginPath();
          context.rect(this.startX, this.startY, width, height);
          context.lineWidth = 7;
          context.strokeStyle = 'red';
          context.stroke();         

         
          this.capturephase = 2;
        }
      },
      doCompletionCanvas() {
        this.tcanvas='completion';
        this.capturing=false;
        this.capturephase=0;
      },
      doNameCanvas() {
        this.tcanvas='name';
        this.capturing=false;
        this.capturephase=0;
      },
      doSave() {
        if (this.NameWidth===null || this.DateWidth===null) {
          this.popDialog(1, "You must capture coordinates for both the name and date fields prior to proceeding");
          return;
        }

        this.apiCommand([
           {
             Operation: "Certificate",
             Function: "UploadStep2",
             Fields: {
               CertificateID: this.CertificateID,
               NameAlign: this.NameAlign,
               NameX: this.NameX,
               NameY: this.NameY,
               NameWidth: this.NameWidth,
               NameHeight: this.NameHeight,
               DateAlign: this.DateAlign,
               DateX: this.DateX,
               DateY: this.DateY,
               DateWidth: this.DateWidth,
               DateHeight: this.DateHeight,
               UseWhiteFont: this.useWhiteFont===true?"true":"false"
             }
           }
        ]).then(r=> {

          this.popDialog(0,"New Certificate Saved Successfully");
          this.$router.push("/client/"+this.$route.params.id+"/certificates");
        })
      },
      doStepOne() {
        if (this.CertificateName.length===0) {
          this.popDialog(1, "Certificate name is required");
          return;
        }

        if (this.fdata===null) {
          this.popDialog(1, "File upload is required");
          return;
        }

        this.apiCommand([
          {
            Operation: "Certificate",
            Function: "UploadStep1",
            Fields: {
              CertificateContents: this.fdata,
              CertificateName: this.CertificateName
            }
          }
        ]).then(response=> {

          var cr = JSON.parse(response.CommandResult);
          if (cr.returnObjects[0].returnObject.length === 36) {

            this.CertificateID = cr.returnObjects[0].returnObject;
            this.CertStyle=this.$hostname+"/Streamable.svc/GetBlankCertificate?CertificateID="+this.CertificateID;
            this.mode='2';
          }
          else {
            this.popDialog(1,"Error: " + cr.returnObjects[0].returnObject);
          }

        });
      },
      getFile(event) {
      
        var r = new FileReader();
        var self=this;
        r.onload = function (e) {
          self.fdata = e.target.result;
        }
        r.readAsDataURL(this.$refs["tfiles"].files[0]);
      }
    },
    mounted() {
      this.doPage().then(r=>{

        this.bootstrapClient(this.$route.params.id);
        if (this.sdata.ispro || this.sdata.isemployee) {
          this.mode='1';
        }

      });
    }
  }
</script>
